import { Component, Loader2 } from "lucide-react";
import { FormattedNumber } from "@/shared/components/FormatNumberProps";
import Tag from "@/shared/components/Tag/Tag";
import { formatPlural } from "@/shared/utils/formatter.utils";
import type { TableCounterProps } from "../types";

export const TableCounter = ({
  isLoading,
  counterType,
  size = "large",
  metadata,
  showTotalAmount = false,
}: TableCounterProps) => {
  // Handle total_count, total_items, and total_item from metadata
  const totalCount = metadata?.total_count ?? metadata?.total_items ?? 0;
  const totalAmount = metadata?.total_amount;

  return (
    <Tag type="counter" size={size}>
      {isLoading
        ? (
          <>
            <Loader2 className="w-3 h-3 animate-spin mr-1" />
            Chargement...
          </>
        )
        : (
          <>
            <span className="flex items-center gap-2">
              <Component className="w-3 h-3 mr-1" />
              {totalCount}
              {" "}
              {formatPlural(totalCount, counterType)}
            </span>

            {(showTotalAmount && totalAmount) && (
              <span className="flex items-center gap-2 h-full border-l border-purple-400 pl-4 ml-2">
                {"Total : "}
                <FormattedNumber value={totalAmount} suffix=" €" />
              </span>
            )}
          </>
        )}
    </Tag>
  );
};
